import React from 'react'
import { useStore } from 'react-admin'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import MenuIcon from '@mui/icons-material/Menu'
import { Sidebar } from './Sidebar'
import { Tagline } from './Tagline'

const SQLayout = (props) => {
  const [hideSidebar, setHideSidebar] = useStore(
    'contracts.review.hideSidebar',
    false
  )

  React.useEffect(() => {
    setHideSidebar(false)
  }, [setHideSidebar])

  return (
    <main className="bg-stone-100/80 text-slate-900">
      <button
        type="button"
        onClick={() => setHideSidebar(!hideSidebar)}
        className="fixed top-4 left-4 z-40 h-9 w-9 rounded-md border border-stone-300 bg-white text-stone-700 shadow-sm hover:bg-stone-50"
        aria-label={hideSidebar ? 'Expand sidebar' : 'Collapse sidebar'}
        title={hideSidebar ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {hideSidebar ? (
          <MenuOpenIcon fontSize="small" />
        ) : (
          <MenuIcon fontSize="small" />
        )}
      </button>
      <div
        className={`flex min-h-screen container mx-auto items-start ${
          hideSidebar ? 'px-6 md:px-8 gap-6' : 'px-12 gap-12 justify-between'
        }`}
      >
        {!hideSidebar && <Sidebar />}
        <div className="pt-10 pb-4 flex-1 min-h-screen min-w-0 flex flex-col justify-between space-y-12">
          <div>{props.children}</div>
          <Tagline />
        </div>
      </div>
    </main>
  )
}

export default SQLayout
